<template>
  <div>
    <div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog"
         aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header p-0">
            <button pt-0 pb-0 type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span class="pr-4" aria-hidden="true">Закрыть</span>
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="modal-body--content d-flex justify-content-between">
              <div class="modal-body--content__left">
                <form id="modal-form" action="" @submit.prevent="addOrder" class="d-flex flex-column mb-4">
                  <h5 class="modal-title title-modal mb-3" id="staticBackdropLabel">Хочу заявки!</h5>
                  <p class="modal-body__text">
                    Для получения заявок, оставьте номер телефона и ваше имя. Наш менеджер расскажет вам все подробнее.
                  </p>
                  <div class="invalid-feedback-head">
                    <input
                        v-model="name"
                        :class="{'is-invalid':($v.name.$dirty && !$v.name.required) || ($v.name.$dirty && !$v.name.minLength)}"
                        class="mb-4 pl-4 py-3 style-input w-100"
                        type="text"
                        placeholder="Ваше Имя"
                        id="modal-name"
                    >
                    <div class="invalid-feedback" v-if="!$v.name.required">Обязательное поле.</div>
                    <div class="invalid-feedback" v-else-if="!$v.name.minLength">Имя должно быть больше 3 букв</div>
                  </div>
                  <div class="invalid-feedback-head">
                    <input
                        v-model="phone"
                        :class="{'is-invalid':($v.phone.$dirty && !$v.phone.required) || ($v.phone.$dirty && !$v.phone.isPhone)}"
                        class="mb-4 pl-4 py-3 style-input phone w-100"
                        type="text"
                        placeholder="+7 (___) ___ - __ - __"
                        id="modal-phone"
                    >
                    <div class="invalid-feedback" v-if="!$v.phone.required">Обязательное поле.</div>
                    <div class="invalid-feedback" v-else-if="!$v.phone.isPhone">Неверный формат номера</div>
                  </div>
                  <!--                                <label class="label-radio">-->
                  <!--                                    <input -->
                  <!--                                        v-model="checkbox"-->
                  <!--                                        :checked="{ 'checked' : checkbox }"-->
                  <!--                                        @change="!checkbox"-->
                  <!--                                        :disabled='isDisabled'-->
                  <!--                                        type="checkbox" -->
                  <!--                                        name="people-number " -->
                  <!--                                        class="real-radio "-->
                  <!--                                        > -->
                  <!--                                    <div class="custom-radio"><img src="/img/modal/chek.svg" alt=""></div>-->
                  <!--                                    <p class="custom-radio&#45;&#45;text" :class="{'is-invalid-checkbox': $v.checkbox.$error}">Согласие на обработку своих персональных данных</p>-->
                  <!--                                </label>-->
                  <div class="modal-footer">
<!--                    <button-->
<!--                        id="modal-submit"-->
<!--                        :disabled='isDisabled'-->
<!--                        type="submit"-->
<!--                        class="btn btn-primary bg-pink"-->
<!--                    >-->
<!--                      <span v-if="isDisabled" class="spinner-grow spinner-grow-sm" role="status"-->
<!--                            aria-hidden="true"></span>-->
<!--                      {{ isDisabled ? 'Отправка данных...' : 'Хочу заявки!' }}-->
<!--                    </button>-->
                    <button
                        id="modal-submit"
                        type="submit"
                        class="btn btn-primary bg-pink"
                    >
                      Хочу заявки!
                    </button>
                  </div>
                  <label class="policy">
                    <input v-model="policy" class="policy__input" type="checkbox">
                    <span class="policy__ok"></span>
                    <span class="policy__text">Я согласен(на) с <a href="/policy" target="_blank">политикой конфиденциальности</a></span>
                    <span class="invalid-feedback invalid-feedback--policy" v-if="!$v.policy.agree && $v.$dirty">Дайте согласие.</span>
                  </label>
                </form>
              </div>
              <div class="modal-body--content__right position-relative">
                <img src="/img/modal/girl.png" class="position-absolute" alt="">
                <div class="body--content__right--color bg-pink position-relative">
                  <img src="/img/top/circles.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {required, minLength} from "vuelidate/lib/validators";
import Inputmask from "inputmask";

export default {
  name: "ModalForm",
  data: () => ({
    name: '',
    phone: '',
    policy: true,
    isAlert: false
  }),
  methods: {
    clearData() {
      this.name = '';
      this.phone = '';
    },
    addOrder() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }
      this.isDisabled = true
      axios.post('/', {
        name: this.name,
        phone: this.phone.replace(/\D/g, ""),
        host: window.location.host,
        referrer: document.referrer,
        url_query_string: window.location.href,

      })
          .then(response => {
            console.log(response)
            this.clearData()
            this.$v.$reset()
            this.isDisabled = false
            if (response.status === 200) {
              $('#staticBackdrop').modal('hide')
              setTimeout(() => this.$store.dispatch('viewThanks'), 500)
              ym(70809001, 'reachGoal', 'order')
              // fbq('track', 'Contact')
              // if (this.counters.google) gtag('event', 'conversion', {'send_to': this.counters.google})
            }
          })
          .catch(error => {
            this.isDisabled = false
            console.log(error.message)
          })
    }
  },
  validations: {
    name: {required, minLength: minLength(3)},
    phone: {
      required,
      isPhone: (phone) => {
        const phoneRe = /^(8|7)[\d]{10}$/;
        if (phone) {
          const digits = phone.replace(/\D/g, "");
          return phoneRe.test(digits)
        }
        return false
      }
    },
    policy: {
      agree: (value) => {
        return value
      }
    },
  },
  mounted() {

    Inputmask({"mask": "+7 (999) - 999 - 99 - 99"}).mask(".phone");
  }
}
</script>

<style scoped>
.is-invalid {
  border: 1px solid #dc3545;
  color: #dc3545;
}

.is-invalid-checkbox {
  color: #dc3545;
}

button[type="submit"]:disabled {
  color: #fff;
}

.alert {
  font-size: 1.6rem;
}

.invalid-feedback-head {
  position: relative;
}

.invalid-feedback {
  position: absolute;
  top: -1.5rem;
  left: 0;
  width: 100%;
}

.invalid-feedback--policy {
  display: block;
  text-align: center;
  top: auto;
  bottom: -15px;
}
</style>
